<template>
  <div class="-wt-mass-produce-finish">
    <div v-if="produceState === produceStates.UPLOAD">
      Sending<wt-ellipsis-animation />
    </div>
    <div v-if="produceState === produceStates.FAILED">
      <div class="-failed">
        <div class="-failed-top">Failed Request</div>
        <div class="-failed-bottom wt2-link" @click="produce">Try Again</div>
      </div>
    </div>
    <div v-if="produceState === produceStates.SUCCESS">
      <div class="-title">That's it!</div>
      <div class="-desc">
        We’re producing your videos, this should take
        <span v-if="estimatedLength > 60">about</span>
        {{ estimatedLengthDisplay }}.
      </div>
      <div class="-desc">We will notify you when ready, you can close now.</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    produceState: {
      type: String,
      required: true,
    },
    produceStates: {
      type: Object,
      required: true,
    },
    produce: {
      type: Function,
      required: true,
    },
    numRows: {
      type: Number,
      required: true,
    },
    storyboard: {
      type: Object,
      required: true,
    },
  },
  computed: {
    videoDuration() {
      return this.storyboard.videoDuration;
    },
    estimatedLength() {
      return (this.numRows * this.videoDuration) / 2;
    },
    estimatedLengthDisplay() {
      return app.moment.duration(this.estimatedLength, 'seconds').humanize();
    },
  },
};
</script>

<style lang="scss" scoped>
.-wt-mass-produce-finish {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: 28px;
  font-weight: 300;
  text-align: center;
  .-title {
    margin-bottom: 30px;
    font-weight: 300;
  }
  .-desc {
    font-size: 14px;
    font-weight: 400;
  }
  .-failed {
    .-failed-top {
      color: #ff3166;
    }
    .-failed-bottom {
      margin-top: 10px;
      font-size: 14px;
      text-decoration: underline;
    }
  }
}
</style>
